// export interface LoginHistoryProps {
//   userEmail: string;
// }

const LoginHistory = () =>
  // {}: LoginHistoryProps
  {
    return null;
  };
export default LoginHistory;
